(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    // 找到当前这个 hero section
    var hero = document.getElementById('Hero-{{ section.id }}');
    if (!hero) return;

    var wrapper = hero.querySelector('.hero__media-wrapper');
    if (!wrapper) return;

    // 通用初始化函数：给一组 slide 做轮播
    function initSlider(slides) {
      if (!slides || slides.length <= 1) return;

      // 除了第一张，其它先全部隐藏
      slides.forEach(function (el, index) {
        if (index !== 0) {
          el.classList.add('hero-slide-hidden');
        }
      });

      var current = 0;
      setInterval(function () {
        // 当前这张隐藏
        slides[current].classList.add('hero-slide-hidden');
        // 指针移到下一张
        current = (current + 1) % slides.length;
        // 下一张显示
        slides[current].classList.remove('hero-slide-hidden');
      }, 5000); // 5000ms = 5 秒一张，可自己改
    }

    // 桌面端：只轮播 desktop 媒体
    var desktopSlides = Array.prototype.slice.call(
      wrapper.querySelectorAll(
        '.hero__image--desktop, .hero__video--desktop, .hero__video-poster--desktop'
      )
    );
    initSlider(desktopSlides);

    // 手机端：只轮播 mobile 媒体
    var mobileSlides = Array.prototype.slice.call(
      wrapper.querySelectorAll(
        '.hero__image--mobile, .hero__video--mobile'
      )
    );
    initSlider(mobileSlides);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
